import React, { useState } from "react";
import { Alert, Button, Col, Form, Row, Space, Modal, Progress } from "antd";
import PageHeading from "../../../../../components/common/PageHeading";
import FilterContainer from "../../../../../components/common/FilterContainer";
import MultiSelect from "../../../../../components/common/MultiSelect";

export const Propertiesunitscampaigns = [
  "test1 - 912 n creek dr  edmond, OK 73034",
  "test2 - 912 n creek dr  edmond, OK 73034 - $0.00",
  "test3 - 1800 canyon park circle  edmond, OK 73013",
  "test4 - 912 n creek dr  edmond, OK 73034 - $0.00",
  "test 5 - 1800 canyon park circle  edmond, OK 73013 - $0.00",
];

const ChargeLateFees = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [visible, SetVisible] = useState(false);
  const countDown = () => {
    let secondsToGo = 1;
    const instance = modal.success({
      title: "Waiting for calculations to finish...",
      content: <Progress percent={secondsToGo * 20} />,
      icon: null,
      okButtonProps: { style: { display: "none" } },
    });
    const timer = setInterval(() => {
      secondsToGo += 1;
      instance.update({
        content: <Progress percent={secondsToGo * 20} />,
      });
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      instance.destroy();
      SetVisible(true);
    }, secondsToGo * 5000);
  };
  return (
    <div>
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
      >
        <Alert
          message="Late Fees are charged automatically at 12 PM each day. This can be configured in Manage Accounting Settings."
          banner
        />
      </Space>
      <PageHeading heading="Charge Late Fees" />
      <FilterContainer>
        <Form name="basic" autoComplete="off" colon={false}>
          <Row gutter={16}>
            <Col span={8} style={{ textAlign: "right" }}>
              <label htmlFor="MultiSelect">
                Properties, Associations, Property Groups, Homeowners, or
                Tenants
              </label>
            </Col>
            <Col span={16}>
              <Form.Item>
                <MultiSelect
                  options={Propertiesunitscampaigns}
                  placeholder="Search by property, group, portfolio, or owner"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <br />
          <Row gutter={16}>
            <Col span={8}></Col>
            <Col span={16}>
              <Button onClick={countDown}>Calculate</Button>
            </Col>
          </Row>
          {contextHolder}
        </Form>
      </FilterContainer>
      {visible ? (
        <>
          <Row gutter={16}>
            <Col>
              <Button type="primary" disabled>
                No charges selected
              </Button>
            </Col>
            <Col>
              <Button disabled>Waive late fees</Button>
            </Col>
          </Row>
          <Row gutter={16} justify="center">
            <Col>
              <p>
                No tenants owing late fees were found that match your criteria.
              </p>
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      <div className="RightSidebar">
      </div>
    </div>
  );
};

export default ChargeLateFees;
